import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styleTattoo from "../../styles/tattoo.module.css";
import SignaturePad from "react-signature-canvas";
import { useCliente } from "../../actions/clientes";
import { toast } from "react-toastify"; // ✅ Usar react-hot-toast

const ContratoTattoo = () => {
   const navigate = useNavigate();
   const location = useLocation();
   const { SaveCliente } = useCliente();
   const { state } = location;
   const token = localStorage.getItem("token");
   let urlContrato = process.env.REACT_APP_URL_DIR + "contratotattoo";
   const [firmaClientePreview, setFirmaClientePreview] = useState(null);
   const [firmaTutorPreview, setFirmaTutorPreview] = useState(null); // ✅ Nuevo
   const clienteSignaturePadRef = useRef();
   const tutorSignaturePadRef = useRef(); // ✅ Nuevo
   const [ynState, setYnState] = useState([
      "n", // pregunta 0
      "n", // pregunta 1
      "n", // pregunta 2
      "n", // pregunta 3
      "n", // pregunta 4
      "n", // pregunta 5
      "n", // pregunta 7
      "n", // pregunta 8
      "n", // pregunta 9
      "n", // pregunta 10
      "n", // pregunta 11
   ]);

   const preguntasSalud = [
      "enfermedadCronica",
      "enfermedadInfecciosa",
      "embarazada",
      "problemaCicatrizacion",
      "hiv",
      "hepatitis",
      "alergiasTatuajes",
      "alergiaAnestesicos",
      "otrasAlergias",
      "medicacionAnticoagulante",
   ];

   const [input, setInput] = useState({
      // Datos Personales
      nombreCompleto: "",
      dni: "",
      fechaNacimiento: "",
      edad: "",
      telefono: "",
      email: "",
      direccion: "",

      // Ficha Técnica
      enfermedadCronica: "",
      enfermedadInfecciosa: "",
      embarazada: "",
      problemaCicatrizacion: "",
      hiv: "",
      hepatitis: "",
      alergiasTatuajes: "",
      alergiaAnestesicos: "",
      otrasAlergias: "",
      medicacionAnticoagulante: "",
      informacionSalud: "",

      // Datos de firma
      fecha: new Date().toISOString().split("T")[0],
      firmado: false,
      firma_digital_cliente: "",

      // ✅ Nuevos campos para menores de edad
      nombreTutor: "",
      firma_digital_tutor: "",

      // IDs relacionales
      clienteId: state?.clienteId || 0,
      presupuestoId: state?.presupuestoId || 0,
   });

   const [errors, setErrors] = useState({});
   const [isSubmitting, setIsSubmitting] = useState(false);

   // Cargar datos del cliente si vienen del state
   // useEffect(() => {
   //    if (state?.cliente) {
   //       setInput((prev) => ({
   //          ...prev,
   //          nombreCompleto: state.cliente.nombre || "",
   //          dni: state.cliente.documento || "",
   //          telefono: state.cliente.telefono || "",
   //          email: state.cliente.email || "",
   //       }));
   //    }
   // }, [state]);

   console.log("location.state.id: ", location.state.id);
   useEffect(() => {
      // Si viene un id en el state y es distinto de 0, buscar los datos
      if (location.state && location.state.id && location.state.id !== 0) {
         fetch(process.env.REACT_APP_URL_DIR + "contratotattoo/" + location.state.id)
            .then((res) => res.json())
            .then((data) => {
               console.log("useEffect data: ", data);
               if (data) {
                  // Carga el primer registro por defecto
                  loadRecord(data);
               }
            });
      }
   }, []);

   function yn_select2(idx, val) {
      setYnState((prev) => {
         const next = [...prev];
         next[idx] = val;
         return next;
      });
   }
   function yn_select3(idx) {
      const checkbox = document.getElementById(`switch_${idx}`);
      if (checkbox.checked) {
         yn_select2(idx, "y");
      } else {
         yn_select2(idx, "n");
      }
   }

   function loadRecord(record) {
      console.log("Cargando registro: ", record);
      // Dejo defaulto en No a todas las preguntas o contestadas
      preguntasSalud.forEach((pregunta, indx) => {
         console.log("record[pregunta]: ", pregunta, `-${record[pregunta]}-`);
         if (record[pregunta] !== "No") {
            ynState[indx] = "y";
         } else {
            record[pregunta] = "";
         }
      });

      setInput({
         nombreCompleto: record.nombreCompleto || "",
         dni: record.dni || "",
         fechaNacimiento: record.fechaNacimiento || "",
         edad: record.edad || "",
         telefono: record.telefono || "",
         email: record.email || "",
         direccion: record.direccion || "",
         enfermedadCronica: record.enfermedadCronica || "",
         enfermedadInfecciosa: record.enfermedadInfecciosa || "",
         embarazada: record.embarazada || "",
         problemaCicatrizacion: record.problemaCicatrizacion || "",
         hiv: record.hiv || "",
         hepatitis: record.hepatitis || "",
         alergiasTatuajes: record.alergiasTatuajes || "",
         alergiaAnestesicos: record.alergiaAnestesicos || "",
         otrasAlergias: record.otrasAlergias || "",
         medicacionAnticoagulante: record.medicacionAnticoagulante || "",
         informacionSalud: record.informacionSalud || "",
         fecha: record.fecha || new Date().toISOString().split("T")[0],
         firmado: record.firmado || false,
         firma_digital_cliente: record.firma_digital_cliente || "",
         // ✅ Cargar campos del tutor
         nombreTutor: record.nombreTutor || "",
         firma_digital_tutor: record.firma_digital_tutor || "",         

         clienteId: record.clienteId || 0,
         presupuestoId: record.presupuestoId || 0,
      });

      setFirmaClientePreview(record.firma_digital_cliente);
      setFirmaTutorPreview(record.firma_digital_tutor); // ✅ Nuevo
   }

   const handleChange = (e) => {
      const { name, value, type, checked } = e.target;
      setInput((prev) => ({
         ...prev,
         [name]: type === "checkbox" ? checked : value,
      }));

      // Limpiar error del campo cuando el usuario empiece a escribir
      if (errors[name]) {
         setErrors((prev) => ({
            ...prev,
            [name]: "",
         }));
      }
   };

   const validateForm = () => {
      const newErrors = {};

      // Validar campos obligatorios
      if (!input.nombreCompleto.trim())
         newErrors.nombreCompleto = "Nombre completo es requerido";
      if (!input.dni.trim()) newErrors.dni = "DNI es requerido";
      if (!input.fechaNacimiento)
         newErrors.fechaNacimiento = "Fecha de nacimiento es requerida";
      if (!input.edad) newErrors.edad = "Edad es requerida";
      if (!input.telefono.trim()) newErrors.telefono = "Teléfono es requerido";
      if (!input.direccion.trim())
         newErrors.direccion = "Dirección es requerida";

      // ✅ Validar campos del tutor si es menor de 18 años
      if (parseInt(input.edad) < 18) {
         if (!input.nombreTutor.trim()) {
            newErrors.nombreTutor = "Nombre del tutor es requerido para menores de 18 años";
         }
         if (!firmaTutorPreview && (!tutorSignaturePadRef.current || tutorSignaturePadRef.current.isEmpty())) {
            newErrors.firmaTutor = "Firma del tutor es requerida para menores de 18 años";
         }
      }


      // Validar que todas las preguntas de salud estén respondidas

      // Dejo defaulto en No a todas las preguntas o contestadas
      preguntasSalud.forEach((pregunta, indx) => {
         if (ynState[indx] === "n") {
            input[pregunta] = "No";
         }
      });

      preguntasSalud.forEach((pregunta) => {
         if (!input[pregunta].trim()) {
            newErrors[pregunta] = "Esta pregunta debe ser respondida";
         }
      });

      if (!input.firmado) {
         newErrors.firmado = "Debe aceptar el formulario de descargo";
      }

      setErrors(newErrors);
      console.log('newErrors: ', newErrors);
     
      return Object.keys(newErrors).length === 0;
   };
   const handleSubmit = async (e) => {
      e.preventDefault();

      if (!validateForm()) {
         console.log("Formulario con errores:", errors);
          toast.error("Formulario con errores. Por favor revise la pagina."); // ✅ Mostrar notificación de error
         return;
      }

      // ✅ Obtener la firma digital del cliente
      const firmaBase64C = clienteSignaturePadRef?.current
         ?.getCanvas()
         ?.toDataURL("image/png");

   // ✅ Obtener la firma digital del tutor si es menor de 18
      const firmaBase64T = parseInt(input.edad) < 18 && tutorSignaturePadRef?.current
         ? tutorSignaturePadRef.current.getCanvas()?.toDataURL("image/png")
         : null;         


      setIsSubmitting(true);

      try {
         let metodo = "POST";
         // ✅ Crear el objeto con los datos incluida la firma
         const dataToSend = {
            ...input,
            firma_digital_cliente: firmaBase64C || null, // ✅ Agregar la firma digital
            firma_digital_tutor: firmaBase64T || null, // ✅ Agregar firma del tutor
         };

         console.log("Datos a enviar:", dataToSend); // Para debug


         if (location.state.id !== 0) {
            metodo = "PUT";
            urlContrato += `/${location.state.id}`;

         }
         const response = await fetch(urlContrato, {
            method: metodo,
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToSend), // ✅ Enviar los datos con la firma
         });
         const Clidata = {
            id_primary: -1, 
            id:0,
            companyId: 0,
            nombre: input.nombreCompleto,
            documento: input.dni,
            email: input.email,
            telefono: input.telefono,
            cod_status: "1",
         };
         // salvo Cliente
         await SaveCliente.mutateAsync(Clidata);

         if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
         }

         const result = await response.json();
         console.log("Contrato guardado:", result);

         // Navegar de vuelta o mostrar mensaje de éxito
         toast.success("Contrato guardado exitosamente!"); // ✅ Mostrar notificación de éxito
         navigate("/contratot");
      } catch (error) {
         console.error("Error al guardar contrato:", error);
         toast.error("Error al guardar el contrato. Por favor, intente nuevamente."); // ✅ Mostrar notificación de error
      } finally {
         setIsSubmitting(false);
      }
   };

   const calcularEdad = (fechaNacimiento) => {
      if (!fechaNacimiento) return "";

      const hoy = new Date();
      const nacimiento = new Date(fechaNacimiento);
      let edad = hoy.getFullYear() - nacimiento.getFullYear();
      const mes = hoy.getMonth() - nacimiento.getMonth();

      if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
         edad--;
      }

      return edad.toString();
   };

   const handleFechaNacimientoChange = (e) => {
      const fecha = e.target.value;
      const edad = calcularEdad(fecha);

      setInput((prev) => ({
         ...prev,
         fechaNacimiento: fecha,
         edad: edad,
      }));
   };
   return (
      <div className={styleTattoo.container}>
         <div className={styleTattoo.formContainer}>
            <h1 className={styleTattoo.title}>CONTRATO DE TATUAJE</h1>

            <form onSubmit={handleSubmit}>
               {/* 1 - DATOS PERSONALES */}
               <section className={styleTattoo.section}>
                  <h2 className={styleTattoo.sectionTitle}>
                     1 - DATOS PERSONALES
                  </h2>

                  <div className={styleTattoo.inputGroup}>
                     <label className={styleTattoo.label}>
                        NOMBRE Y APELLIDO: *
                        <input
                           type="text"
                           name="nombreCompleto"
                           value={input.nombreCompleto}
                           onChange={handleChange}
                           className={`${styleTattoo.input} ${
                              errors.nombreCompleto
                                 ? styleTattoo.inputError
                                 : ""
                           }`}
                           placeholder="Ingrese nombre completo"
                        />
                        {errors.nombreCompleto && (
                           <span className={styleTattoo.error}>
                              {errors.nombreCompleto}
                           </span>
                        )}
                     </label>
                  </div>

                  <div className={styleTattoo.inputGroup}>
                     <label className={styleTattoo.label}>
                        DNI: *
                        <input
                           type="text"
                           name="dni"
                           value={input.dni}
                           onChange={handleChange}
                           className={`${styleTattoo.input} ${
                              errors.dni ? styleTattoo.inputError : ""
                           }`}
                           placeholder="Ingrese DNI"
                        />
                        {errors.dni && (
                           <span className={styleTattoo.error}>
                              {errors.dni}
                           </span>
                        )}
                     </label>
                  </div>

                  <div className={styleTattoo.inputRow}>
                     <div className={styleTattoo.inputGroup}>
                        <label className={styleTattoo.label}>
                           FECHA DE NACIMIENTO: *
                           <input
                              type="date"
                              name="fechaNacimiento"
                              value={input.fechaNacimiento}
                              onChange={handleFechaNacimientoChange}
                              className={`${styleTattoo.input} ${
                                 errors.fechaNacimiento
                                    ? styleTattoo.inputError
                                    : ""
                              }`}
                           />
                           {errors.fechaNacimiento && (
                              <span className={styleTattoo.error}>
                                 {errors.fechaNacimiento}
                              </span>
                           )}
                        </label>
                     </div>

                     <div className={styleTattoo.inputGroup}>
                        <label className={styleTattoo.label}>
                           EDAD: *
                           <input
                              type="number"
                              name="edad"
                              value={input.edad}
                              onChange={handleChange}
                              className={`${styleTattoo.input} ${
                                 errors.edad ? styleTattoo.inputError : ""
                              }`}
                              placeholder="Edad"
                              readOnly
                           />
                           {errors.edad && (
                              <span className={styleTattoo.error}>
                                 {errors.edad}
                              </span>
                           )}
                        </label>
                     </div>
                  </div>

                  <div className={styleTattoo.inputGroup}>
                     <label className={styleTattoo.label}>
                        TELÉFONO: *
                        <input
                           type="tel"
                           name="telefono"
                           value={input.telefono}
                           onChange={handleChange}
                           className={`${styleTattoo.input} ${
                              errors.telefono ? styleTattoo.inputError : ""
                           }`}
                           placeholder="Ingrese teléfono"
                        />
                        {errors.telefono && (
                           <span className={styleTattoo.error}>
                              {errors.telefono}
                           </span>
                        )}
                     </label>
                  </div>

                  <div className={styleTattoo.inputGroup}>
                     <label className={styleTattoo.label}>
                        MAIL:
                        <input
                           type="email"
                           name="email"
                           value={input.email}
                           onChange={handleChange}
                           className={styleTattoo.input}
                           placeholder="Ingrese email"
                        />
                     </label>
                  </div>

                  <div className={styleTattoo.inputGroup}>
                     <label className={styleTattoo.label}>
                        DIRECCIÓN: *
                        <input
                           type="text"
                           name="direccion"
                           value={input.direccion}
                           onChange={handleChange}
                           className={`${styleTattoo.input} ${
                              errors.direccion ? styleTattoo.inputError : ""
                           }`}
                           placeholder="Ingrese dirección completa"
                        />
                        {errors.direccion && (
                           <span className={styleTattoo.error}>
                              {errors.direccion}
                           </span>
                        )}
                     </label>
                  </div>
               </section>

               {/* 2 - FICHA TÉCNICA */}
               <section className={styleTattoo.section}>
                  <h2 className={styleTattoo.sectionTitle}>
                     2 - FICHA TÉCNICA - CONTAME DE VOS !
                  </h2>

                  <div className={styleTattoo.questionGroup}>
                     <label className="switch">
                        <input
                           id="switch_0"
                           type="checkbox"
                           checked={ynState[0] === "y"}
                           onClick={() => yn_select3(0)}
                        />
                        <span className="slider round">
                           <span
                              style={{
                                 marginLeft:
                                    ynState[0] === "y" ? "10px" : "35px",
                                 marginTop: "5px",
                                 fontWeight: "bold",
                                 fontSize: "24px",
                                 color:
                                    ynState[0] === "y"
                                       ? "#067d22ff"
                                       : "#dc3545",
                              }}
                           >
                              {ynState[0] === "y" ? "Si" : "No"}
                           </span>
                        </span>
                     </label>
                     <label className={styleTattoo.question}>
                        ¿Tenés alguna enfermedad crónica? *
                        {ynState[0] === "y" && (
                           <>
                              <textarea
                                 name="enfermedadCronica"
                                 value={input.enfermedadCronica}
                                 onChange={handleChange}
                                 className={`${styleTattoo.textarea} ${
                                    errors.enfermedadCronica
                                       ? styleTattoo.inputError
                                       : ""
                                 }`}
                                 placeholder="Responda detalladamente"
                                 rows="2"
                              />
                              {errors.enfermedadCronica && (
                                 <span className={styleTattoo.error}>
                                    {errors.enfermedadCronica}
                                 </span>
                              )}
                           </>
                        )}
                     </label>
                  </div>

                  <div className={styleTattoo.questionGroup}>
                     <label className="switch">
                        <input
                           id="switch_1"
                           type="checkbox"
                           checked={ynState[1] === "y"}
                           onClick={() => yn_select3(1)}
                        />
                        <span className="slider round">
                           <span
                              style={{
                                 marginLeft:
                                    ynState[1] === "y" ? "10px" : "35px",
                                 marginTop: "5px",
                                 fontWeight: "bold",
                                 fontSize: "24px",
                                 color:
                                    ynState[1] === "y"
                                       ? "#067d22ff"
                                       : "#dc3545",
                              }}
                           >
                              {ynState[1] === "y" ? "Si" : "No"}
                           </span>
                        </span>
                     </label>
                     <label className={styleTattoo.question}>
                        ¿Tuviste alguna enfermedad infecciosa los últimos meses?
                        *
                        {ynState[1] === "y" && (
                           <>
                              <textarea
                                 name="enfermedadInfecciosa"
                                 value={input.enfermedadInfecciosa}
                                 onChange={handleChange}
                                 className={`${styleTattoo.textarea} ${
                                    errors.enfermedadInfecciosa
                                       ? styleTattoo.inputError
                                       : ""
                                 }`}
                                 placeholder="Responda detalladamente"
                                 rows="2"
                              />
                              {errors.enfermedadInfecciosa && (
                                 <span className={styleTattoo.error}>
                                    {errors.enfermedadInfecciosa}
                                 </span>
                              )}
                           </>
                        )}
                     </label>
                  </div>

                  <div className={styleTattoo.questionGroup}>
                     <label className="switch">
                        <input
                           id="switch_2"
                           type="checkbox"
                           checked={ynState[2] === "y"}
                           onClick={() => yn_select3(2)}
                        />
                        <span className="slider round">
                           <span
                              style={{
                                 marginLeft:
                                    ynState[2] === "y" ? "10px" : "35px",
                                 marginTop: "5px",
                                 fontWeight: "bold",
                                 fontSize: "24px",
                                 color:
                                    ynState[2] === "y"
                                       ? "#067d22ff"
                                       : "#dc3545",
                              }}
                           >
                              {ynState[2] === "y" ? "Si" : "No"}
                           </span>
                        </span>
                     </label>

                     <label className={styleTattoo.question}>
                        ¿Estás embarazada? *
                        {ynState[2] === "y" && (
                           <>
                              <textarea
                                 name="embarazada"
                                 value={input.embarazada}
                                 onChange={handleChange}
                                 className={`${styleTattoo.textarea} ${
                                    errors.embarazada
                                       ? styleTattoo.inputError
                                       : ""
                                 }`}
                                 placeholder="Responda detalladamente"
                                 rows="2"
                              />
                              {errors.embarazada && (
                                 <span className={styleTattoo.error}>
                                    {errors.embarazada}
                                 </span>
                              )}
                           </>
                        )}
                     </label>
                  </div>

                  <div className={styleTattoo.questionGroup}>
                     <label className="switch">
                        <input
                           id="switch_3"
                           type="checkbox"
                           checked={ynState[3] === "y"}
                           onClick={() => yn_select3(3)}
                        />
                        <span className="slider round">
                           <span
                              style={{
                                 marginLeft:
                                    ynState[3] === "y" ? "10px" : "35px",
                                 marginTop: "5px",
                                 fontWeight: "bold",
                                 fontSize: "24px",
                                 color:
                                    ynState[3] === "y"
                                       ? "#067d22ff"
                                       : "#dc3545",
                              }}
                           >
                              {ynState[3] === "y" ? "Si" : "No"}
                           </span>
                        </span>
                     </label>

                     <label className={styleTattoo.question}>
                        ¿Tenés algún problema de cicatrización?, ¿cicatrización
                        queloide? *
                        {ynState[3] === "y" && (
                           <>
                              <textarea
                                 name="problemaCicatrizacion"
                                 value={input.problemaCicatrizacion}
                                 onChange={handleChange}
                                 className={`${styleTattoo.textarea} ${
                                    errors.problemaCicatrizacion
                                       ? styleTattoo.inputError
                                       : ""
                                 }`}
                                 placeholder="Responda detalladamente"
                                 rows="2"
                              />
                              {errors.problemaCicatrizacion && (
                                 <span className={styleTattoo.error}>
                                    {errors.problemaCicatrizacion}
                                 </span>
                              )}
                           </>
                        )}
                     </label>
                  </div>

                  <div className={styleTattoo.questionGroup}>
                     <label className="switch">
                        <input
                           id="switch_4"
                           type="checkbox"
                           checked={ynState[4] === "y"}
                           onClick={() => yn_select3(4)}
                        />
                        <span className="slider round">
                           <span
                              style={{
                                 marginLeft:
                                    ynState[4] === "y" ? "10px" : "35px",
                                 marginTop: "5px",
                                 fontWeight: "bold",
                                 fontSize: "24px",
                                 color:
                                    ynState[4] === "y"
                                       ? "#067d22ff"
                                       : "#dc3545",
                              }}
                           >
                              {ynState[4] === "y" ? "Si" : "No"}
                           </span>
                        </span>
                     </label>

                     <label className={styleTattoo.question}>
                        ¿Tenés HIV? *
                        {ynState[4] === "y" && (
                           <>
                              <textarea
                                 name="hiv"
                                 value={input.hiv}
                                 onChange={handleChange}
                                 className={`${styleTattoo.textarea} ${
                                    errors.hiv ? styleTattoo.inputError : ""
                                 }`}
                                 placeholder="Responda detalladamente"
                                 rows="2"
                              />
                              {errors.hiv && (
                                 <span className={styleTattoo.error}>
                                    {errors.hiv}
                                 </span>
                              )}
                           </>
                        )}
                     </label>
                  </div>

                  <div className={styleTattoo.questionGroup}>
                     <label className="switch">
                        <input
                           id="switch_5"
                           type="checkbox"
                           checked={ynState[5] === "y"}
                           onClick={() => yn_select3(5)}
                        />
                        <span className="slider round">
                           <span
                              style={{
                                 marginLeft:
                                    ynState[5] === "y" ? "10px" : "35px",
                                 marginTop: "5px",
                                 fontWeight: "bold",
                                 fontSize: "24px",
                                 color:
                                    ynState[5] === "y"
                                       ? "#067d22ff"
                                       : "#dc3545",
                              }}
                           >
                              {ynState[5] === "y" ? "Si" : "No"}
                           </span>
                        </span>
                     </label>

                     <label className={styleTattoo.question}>
                        ¿Tenés hepatitis? *
                        {ynState[5] === "y" && (
                           <>
                              <textarea
                                 name="hepatitis"
                                 value={input.hepatitis}
                                 onChange={handleChange}
                                 className={`${styleTattoo.textarea} ${
                                    errors.hepatitis
                                       ? styleTattoo.inputError
                                       : ""
                                 }`}
                                 placeholder="Responda detalladamente"
                                 rows="2"
                              />
                              {errors.hepatitis && (
                                 <span className={styleTattoo.error}>
                                    {errors.hepatitis}
                                 </span>
                              )}
                           </>
                        )}
                     </label>
                  </div>

                  <div className={styleTattoo.questionGroup}>
                     <label className="switch">
                        <input
                           id="switch_6"
                           type="checkbox"
                           checked={ynState[6] === "y"}
                           onClick={() => yn_select3(6)}
                        />
                        <span className="slider round">
                           <span
                              style={{
                                 marginLeft:
                                    ynState[0] === "y" ? "10px" : "35px",
                                 marginTop: "5px",
                                 fontWeight: "bold",
                                 fontSize: "24px",
                                 color:
                                    ynState[6] === "y"
                                       ? "#067d22ff"
                                       : "#dc3545",
                              }}
                           >
                              {ynState[6] === "y" ? "Si" : "No"}
                           </span>
                        </span>
                     </label>

                     <label className={styleTattoo.question}>
                        ¿Reaccionaste con alergia a tatuajes anteriores? *
                        {ynState[6] === "y" && (
                           <>
                              <textarea
                                 name="alergiasTatuajes"
                                 value={input.alergiasTatuajes}
                                 onChange={handleChange}
                                 className={`${styleTattoo.textarea} ${
                                    errors.alergiasTatuajes
                                       ? styleTattoo.inputError
                                       : ""
                                 }`}
                                 placeholder="Responda detalladamente"
                                 rows="2"
                              />
                              {errors.alergiasTatuajes && (
                                 <span className={styleTattoo.error}>
                                    {errors.alergiasTatuajes}
                                 </span>
                              )}
                           </>
                        )}
                     </label>
                  </div>

                  <div className={styleTattoo.questionGroup}>
                     <label className="switch">
                        <input
                           id="switch_7"
                           type="checkbox"
                           checked={ynState[7] === "y"}
                           onClick={() => yn_select3(7)}
                        />
                        <span className="slider round">
                           <span
                              style={{
                                 marginLeft:
                                    ynState[7] === "y" ? "10px" : "35px",
                                 marginTop: "5px",
                                 fontWeight: "bold",
                                 fontSize: "24px",
                                 color:
                                    ynState[7] === "y"
                                       ? "#067d22ff"
                                       : "#dc3545",
                              }}
                           >
                              {ynState[7] === "y" ? "Si" : "No"}
                           </span>
                        </span>
                     </label>

                     <label className={styleTattoo.question}>
                        ¿Sos alérgica/o a anestésicos locales como lidocaína,
                        tetracaína, procaína o benzocaína? *
                        {ynState[7] === "y" && (
                           <>
                              <textarea
                                 name="alergiaAnestesicos"
                                 value={input.alergiaAnestesicos}
                                 onChange={handleChange}
                                 className={`${styleTattoo.textarea} ${
                                    errors.alergiaAnestesicos
                                       ? styleTattoo.inputError
                                       : ""
                                 }`}
                                 placeholder="Responda detalladamente"
                                 rows="2"
                              />
                              {errors.alergiaAnestesicos && (
                                 <span className={styleTattoo.error}>
                                    {errors.alergiaAnestesicos}
                                 </span>
                              )}
                           </>
                        )}
                     </label>
                  </div>

                  <div className={styleTattoo.questionGroup}>
                     <label className="switch">
                        <input
                           id="switch_8"
                           type="checkbox"
                           checked={ynState[8] === "y"}
                           onClick={() => yn_select3(8)}
                        />
                        <span className="slider round">
                           <span
                              style={{
                                 marginLeft:
                                    ynState[8] === "y" ? "10px" : "35px",
                                 marginTop: "5px",
                                 fontWeight: "bold",
                                 fontSize: "24px",
                                 color:
                                    ynState[8] === "y"
                                       ? "#067d22ff"
                                       : "#dc3545",
                              }}
                           >
                              {ynState[8] === "y" ? "Si" : "No"}
                           </span>
                        </span>
                     </label>

                     <label className={styleTattoo.question}>
                        ¿Tenés algún otro tipo de alergia? *
                        {ynState[8] === "y" && (
                           <>
                              <textarea
                                 name="otrasAlergias"
                                 value={input.otrasAlergias}
                                 onChange={handleChange}
                                 className={`${styleTattoo.textarea} ${
                                    errors.otrasAlergias
                                       ? styleTattoo.inputError
                                       : ""
                                 }`}
                                 placeholder="Responda detalladamente"
                                 rows="2"
                              />
                              {errors.otrasAlergias && (
                                 <span className={styleTattoo.error}>
                                    {errors.otrasAlergias}
                                 </span>
                              )}
                           </>
                        )}
                     </label>
                  </div>

                  <div className={styleTattoo.questionGroup}>
                     <label className="switch">
                        <input
                           id="switch_9"
                           type="checkbox"
                           checked={ynState[9] === "y"}
                           onClick={() => yn_select3(9)}
                        />
                        <span className="slider round">
                           <span
                              style={{
                                 marginLeft:
                                    ynState[9] === "y" ? "10px" : "35px",
                                 marginTop: "5px",
                                 fontWeight: "bold",
                                 fontSize: "24px",
                                 color:
                                    ynState[9] === "y"
                                       ? "#067d22ff"
                                       : "#dc3545",
                              }}
                           >
                              {ynState[9] === "y" ? "Si" : "No"}
                           </span>
                        </span>
                     </label>

                     <label className={styleTattoo.question}>
                        ¿Tomás alguna medicación anticoagulante como heparina,
                        aspirina? *
                        {ynState[9] === "y" && (
                           <>
                              <textarea
                                 name="medicacionAnticoagulante"
                                 value={input.medicacionAnticoagulante}
                                 onChange={handleChange}
                                 className={`${styleTattoo.textarea} ${
                                    errors.medicacionAnticoagulante
                                       ? styleTattoo.inputError
                                       : ""
                                 }`}
                                 placeholder="Responda detalladamente"
                                 rows="2"
                              />
                              {errors.medicacionAnticoagulante && (
                                 <span className={styleTattoo.error}>
                                    {errors.medicacionAnticoagulante}
                                 </span>
                              )}
                           </>
                        )}
                     </label>
                  </div>

                  <div className={styleTattoo.questionGroup}>
                     <label className="switch">
                        <input
                           id="switch_10"
                           type="checkbox"
                           checked={ynState[10] === "y"}
                           onClick={() => yn_select3(10)}
                        />
                        <span className="slider round">
                           <span
                              style={{
                                 marginLeft:
                                    ynState[10] === "y" ? "10px" : "35px",
                                 marginTop: "5px",
                                 fontWeight: "bold",
                                 fontSize: "24px",
                                 color:
                                    ynState[10] === "y"
                                       ? "#067d22ff"
                                       : "#dc3545",
                              }}
                           >
                              {ynState[10] === "y" ? "Si" : "No"}
                           </span>
                        </span>
                     </label>

                     <label className={styleTattoo.question}>
                        ¿Algo que debas informarnos respecto a tu salud?
                        {ynState[10] === "y" && (
                           <>
                              <textarea
                                 name="informacionSalud"
                                 value={input.informacionSalud}
                                 onChange={handleChange}
                                 className={styleTattoo.textarea}
                                 placeholder="Información adicional sobre su salud"
                                 rows="3"
                              />
                           </>
                        )}
                     </label>
                  </div>
               </section>

               {/* 3 - FORMULARIO DE DESCARGO */}
               <section className={styleTattoo.section}>
                  <h2 className={styleTattoo.sectionTitle}>
                     3 - FORMULARIO DE DESCARGO
                  </h2>

                  <div className={styleTattoo.disclaimerText}>
                     <p>
                        Fui informada/o que ciertas tintas pueden llegar a ser
                        perjudiciales a la salud generando algún tipo de
                        reacción alérgica. Todo el material con el que se
                        trabaja es estéril, descartable y abierto ante mis ojos.
                        Declaro haber completado fielmente la ficha técnica y
                        haber cumplido con las recomendaciones recibidas antes
                        de la sesión de tatuaje. En base a todo lo anteriormente
                        citado estoy de acuerdo a realizarme el tatuaje y me
                        comprometo a cumplir con los cuidados posteriores ya
                        informados.
                     </p>
                  </div>

                  <div className={styleTattoo.signatureSection}>
                     <div className={styleTattoo.checkboxGroup}>
                        <label className={styleTattoo.checkboxLabel}>
                           <input
                              type="checkbox"
                              name="firmado"
                              checked={input.firmado}
                              onChange={handleChange}
                              className={styleTattoo.checkbox}
                           />
                           Acepto el formulario de descargo y confirmo que toda
                           la información proporcionada es veraz *
                        </label>
                        {errors.firmado && (
                           <span className={styleTattoo.error}>
                              {errors.firmado}
                           </span>
                        )}
                     </div>

                     {firmaClientePreview ? (
                        <div style={{ margin: "16px 0" }}>
                           <img
                              src={firmaClientePreview}
                              alt="Firma cliente"
                              style={{
                                 maxWidth: "300px",
                                 maxHeight: "120px",
                                 border: "1px solid #ccc",
                                 borderRadius: "8px",
                              }}
                           />
                        </div>
                     ) : (
                        <div style={{ margin: "16px 0" }}>
                           <label className={styleTattoo.question}>Firma</label>
                           <SignaturePad
                              canvasProps={{
                                 width: 635,
                                 height: 240,
                                 style: {
                                    border: "1px solid #aeaeaeff",
                                    borderRadius: "8px",
                                 },
                              }}
                              ref={clienteSignaturePadRef}
                           />
                           <button
                              type="button"
                              style={{ marginTop: "8px" }}
                              onClick={() =>
                                 clienteSignaturePadRef.current.clear()
                              }
                           >
                              Limpiar Firma Digital
                           </button>
                        </div>
                     )}

                     {/* ✅ Sección para menores de 18 años */}

                     {parseInt(input.edad) < 18 && (
                        <>
                           <div className={styleTattoo.inputGroup} style={{ marginTop: "24px" }}>
                              <label className={styleTattoo.label}>
                                 NOMBRE DEL TUTOR/PADRE/MADRE: *
                                 <input
                                    type="text"
                                    name="nombreTutor"
                                    value={input.nombreTutor}
                                    onChange={handleChange}
                                    className={`${styleTattoo.input} ${
                                       errors.nombreTutor ? styleTattoo.inputError : ""
                                    }`}
                                    placeholder="Ingrese nombre completo del tutor"
                                 />
                                 {errors.nombreTutor && (
                                    <span className={styleTattoo.error}>
                                       {errors.nombreTutor}
                                    </span>
                                 )}
                              </label>
                           </div>

                           <div style={{ margin: "16px 0" }}>
                              <label className={styleTattoo.question}>Firma del Tutor *</label>
                              {firmaTutorPreview ? (
                                 <div style={{ margin: "16px 0" }}>
                                    <img
                                       src={firmaTutorPreview}
                                       alt="Firma tutor"
                                       style={{
                                          maxWidth: "300px",
                                          maxHeight: "120px",
                                          border: "1px solid #ccc",
                                          borderRadius: "8px",
                                       }}
                                    />
                                 </div>
                              ) : (
                                 <>
                                    <SignaturePad
                                       canvasProps={{
                                          width: 635,
                                          height: 240,
                                          style: {
                                             border: "1px solid #aeaeaeff",
                                             borderRadius: "8px",
                                          },
                                       }}
                                       ref={tutorSignaturePadRef}
                                    />
                                    <button
                                       type="button"
                                       style={{ marginTop: "8px" }}
                                       onClick={() => tutorSignaturePadRef.current.clear()}
                                    >
                                       Limpiar Firma del Tutor
                                    </button>
                                 </>
                              )}
                              {errors.firmaTutor && (
                                 <span className={styleTattoo.error}>
                                    {errors.firmaTutor}
                                 </span>
                              )}
                           </div>
                        </>
                     )}
                     <div className={styleTattoo.dateGroup}>
                        <label className={styleTattoo.label}>
                           FECHA:
                           <input
                              type="date"
                              name="fecha"
                              value={input.fecha}
                              onChange={handleChange}
                              className={styleTattoo.input}
                           />
                        </label>
                     </div>
                  </div>
               </section>

               {/* Botones */}
               <div className={styleTattoo.buttonGroup}>
                  <button
                     type="button"
                     onClick={() => navigate(-1)}
                     className={styleTattoo.cancelButton}
                     disabled={isSubmitting}
                  >
                    {location.state.id === 0 ? "Cancelar" : "Volver"}
                  </button>
                 {location.state.id === 0 ? (
                  <button
                     type="submit"
                     className={styleTattoo.submitButton}
                     disabled={isSubmitting}
                  >
                     {isSubmitting ? "Guardando..." : "Guardar Contrato"}
                  </button>
                 ):(null)}
               </div>
            </form>
         </div>
      </div>
   );
};

export default ContratoTattoo;
